<template>
  <div v-if="resource && !loading">
    <router-link :to="{ name: redirect, params: { slug: resource.slug } }">
      <figure v-if="resource.cover" class="image is-2by3">
        <div
          class="bookmark-icon tw-absolute tw-z-20 tw-bg-white"
          v-if="resource.is_bookmarked"
        >
          <b-icon type="is-danger" icon="mdi mdi-bookmark"></b-icon>
        </div>
        <img v-lazy="resource.cover.url" />
      </figure>
    </router-link>
  </div>
</template>

<script>
import Resource from '@/models/Resource'

export default {
  props: {
    resource: {
      type: Resource
    },
    redirect: {
      type: String
    },
    loading: { type: Boolean }
  }
}
</script>

<style lang="scss" scoped>
.bookmark-icon {
  display: inline-block;
  padding: 10px;
  line-height: 0;
  top: -10px;
  left: -13px;
  border-radius: 20px;
}
</style>
